module.exports = __webpack_public_path__ + "img/icon2.bd12b5fe.svg";